import { createContext } from 'react';
export var IndexBarContext = /*#__PURE__*/createContext({
  indexes: [],
  setIndexes: function setIndexes() {}
});